const tabSection = document.querySelectorAll(".js-tab-section");

tabSection.forEach((tabSection) => {
	const tabButtons: null | NodeListOf<HTMLButtonElement> =
		tabSection.querySelectorAll(".js-tab-button");
	const tabs: null | NodeListOf<HTMLElement> = tabSection.querySelectorAll(".tabs .js-tab");

	function makeActive(nodeList, index) {
		nodeList.forEach((button) => {
			if (button.dataset.tabId == index) {
				button.classList.add("active");
				
			} else {
				button.classList.remove("active");
			}
		});
		
	}

	tabButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			const activeButton: HTMLElement = e.target as HTMLElement;
			const index = activeButton.dataset.tabId;

			makeActive(tabButtons, index);
			makeActive(tabs, index);
			window.dispatchEvent(new Event("resize"));
		});
	});

    //init tabs
    makeActive(tabButtons, 0);
    makeActive(tabs, 0)
	window.dispatchEvent(new Event("resize"));

	if(window.location.href.includes('#compare')) {
		makeActive(tabButtons, 1);
		makeActive(tabs, 1);
		window.dispatchEvent(new Event("resize"));
	}
});
